import { createGridSelectionContext } from "@/components/ui/ag-grid-table/createGridSelectionContext";

const { Provider, useStore } = createGridSelectionContext<string>("useTracesSelectionStore");

export const TracesSelectionProvider = Provider;
export const useTracesSelectionStore = useStore;
